// Document-type glossaries per job category.
// Source of truth: docs/data-structure.html §"Document types — received_docs values".
// P / I (Issuer / Proxy) and CA use full document names; R uses short codes.

export type JobCategory = 'P' | 'I' | 'CA' | 'R';

export const CATEGORY_META: Record<JobCategory, { label: string; tp: string }> = {
  P:  { label: 'Proxy',       tp: 'tp tp-px' },
  I:  { label: 'Issuer',      tp: 'tp tp-px' },
  CA: { label: 'Corp Action', tp: 'tp tp-ca' },
  R:  { label: 'Regulatory',  tp: 'tp tp-rg' },
};

// Issuer / Proxy (P · I) — full document names.
const PROXY_ISSUER_DOCS = [
  '10K', '10K/A', '8K', 'Annual Report', 'Annual Report/10K', 'BRE', 'Buckslip',
  'Consolidated Financial Statements', 'Depositary Notice', 'Financial Statements',
  'Form 6K/Notice/Proxy Statement', 'Information Statement', 'Information Statement/Prospectus',
  'Management Circular', 'Management Discussion & Analysis', 'Notice', 'Notice Document (NAA Letter)',
  'Notice/Circular', 'Notice/Circular/Proxy Statement', 'Notice/Proxy Statement',
  'Notice/Proxy Statement/10K', 'Notice/Proxy Statement/Prospectus', 'Press Release', 'Prospectus',
  'Proxy Statement', 'Quarterly Report', 'Request Form', 'Schedule 14A/Notice/Circular',
  'Schedule 14A/Notice/Proxy Statement', 'Schedule 14A/Notice/Supplement',
  'Schedule 14A/Notice/Information Statement', 'Semi-Annual Report', 'Shareholder Letter',
  'Shareholder Letter/10K', 'VIF', 'Virtual Meeting Guide', 'Wrap (Notice/Proxy Statement/AR)',
  'Wrap (Notice/Proxy Statement/AR/10K)',
];

// Corporate Actions (CA). Last two added from real REORG scans (data/uploads/ca).
const CA_DOCS = [
  'Beneficial Ballot', 'Broker Letter', 'Client Letter', 'Letter of Transmittal',
  'Master Ballot', 'Notice', 'Notice of Guaranteed Delivery', 'Offer to Purchase',
  'Prospectus', 'Rights Offering', 'Schedule 14D9', 'Shareholder Letter',
];

// Regulatory (R) — short codes.
const REGULATORY_DOCS = ['PROS', 'SP', 'SUPP', 'SA/SR'];

export function docTypesFor(category: JobCategory): string[] {
  switch (category) {
    case 'CA': return CA_DOCS;
    case 'R':  return REGULATORY_DOCS;
    case 'P':
    case 'I':
    default:   return PROXY_ISSUER_DOCS;
  }
}

// R uses one general-tag layout per category; only R is a separate ("regulatory") form.
export const isRegulatory = (category: JobCategory) => category === 'R';
